// Psychologist/usePsychologist.ts
import {useContext, useEffect, useState} from 'react';
import {axios} from 'Auth/axiosConfig';
import pprint from '../../Utils/pprint';
import {AuthContext, AuthContextType} from 'Auth/AuthContext';
import {IPsychologist} from '../../Types/psychology/psychologist';
import {useErrorProcessing} from 'Core/components/ErrorProvider';

export function usePsychologist(finalId?: string | number, propPsychologist?: IPsychologist | null) {
    const [psychologist, setPsychologist] = useState<IPsychologist | null>(propPsychologist || null);
    const [notFound, setNotFound] = useState(false);
    const [loading, setLoading] = useState(true);
    const {isAuthenticated} = useContext(AuthContext) as AuthContextType;
    const {byResponse} = useErrorProcessing();

    useEffect(() => {
        if (psychologist) {
            setLoading(false);
            return;
        }
        if (!finalId) return;

        axios.get(`/api/v1/psychologists/${finalId}/`)
            .then((response) => {
                if (response.data) {
                    pprint(`Psychologist:${finalId}`);
                    console.log(response.data)
                    setPsychologist(response.data);
                } else {
                    setNotFound(true);
                }
                setLoading(false);
            })
            .catch((error) => byResponse(error));
    }, [finalId, isAuthenticated, byResponse, psychologist]);

    return {psychologist, loading, notFound};
}